/* TODO: t() */
import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { Text, Button } from '../uiold';
import { themeColors } from '../uiold/Constants';

export default function HomePage(props: {
  marketName: string;
  toggleLoginModal: (arg0: boolean) => void;
}) {
  let { marketName, toggleLoginModal } = props;
  return (
    <View style={styles.root}>
      <View style={styles.homeContainer}>
        <View>
          <Text style={styles.welcomeTitle}>WELCOME TO</Text>
          <Text style={styles.emptyTitle}>{marketName}</Text>
          <Text style={styles.emptySubtitle}>
            Please click the button below to login or register.
          </Text>
          <View style={styles.buttonContainer}>
            <Button
              style={{ marginRight: 16 }}
              textStyle={{ paddingHorizontal: 86 }}
              buttonSize="large"
              title="Log In / Register"
              isPrimary
              onPress={() => {
                toggleLoginModal(true);
              }}
            />
          </View>
        </View>
        <View style={styles.imageContainer}>
          <Image
            style={styles.emptyLogo}
            resizeMode="contain"
            source={{ uri: '/assets/images/mp-empty.png' }}
          />
        </View>
      </View>
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  homeContainer: {
    flexDirection: 'column',
  },
  emptyLogo: {
    width: '100%',
    height: '100%',
  },
  imageContainer: {
    height: '100%',
  },
  welcomeTitle: {
    color: themeColors.headerGrey,
    fontSize: 20,
    fontWeight: '500',
  },
  buttonContainer: {
    flexDirection: 'row',
    marginVertical: 20,
  },
  emptyTitle: {
    color: themeColors.black,
    fontSize: 42,
    fontWeight: 'bold',
    paddingVertical: 16,
  },
  emptySubtitle: {
    fontSize: 20,
    marginTop: 5,
  },
});
